import type { OnboardingProgress } from '../types/onboarding';

export const ONBOARDING_UPDATE_EVENT = 'narrativebench:onboarding-update';

export type OnboardingUpdatePayload = {
  actionId: string;
  newlyCompleted: boolean;
  pointsAwarded: number;
  newlyGrantedMilestones: string[];
  progress: OnboardingProgress;
};

function isOnboardingUpdatePayload(value: unknown): value is OnboardingUpdatePayload {
  if (!value || typeof value !== 'object') {
    return false;
  }
  const payload = value as Partial<OnboardingUpdatePayload>;
  return (
    typeof payload.actionId === 'string' &&
    typeof payload.newlyCompleted === 'boolean' &&
    typeof payload.pointsAwarded === 'number' &&
    Array.isArray(payload.newlyGrantedMilestones) &&
    !!payload.progress &&
    typeof payload.progress === 'object'
  );
}

export function notifyOnboardingUpdate(payload: unknown): void {
  if (!isOnboardingUpdatePayload(payload)) {
    return;
  }
  if (!payload.newlyCompleted && payload.newlyGrantedMilestones.length === 0) {
    return;
  }
  window.dispatchEvent(new CustomEvent(ONBOARDING_UPDATE_EVENT, { detail: payload }));
}

export async function readJsonWithOnboarding<T extends object>(response: Response): Promise<T> {
  const data = (await response.json()) as T & { onboarding?: unknown };
  notifyOnboardingUpdate(data.onboarding);
  return data;
}
